import React, { Component } from 'react';
import { CaseTile, PaddedSection } from '../../atoms';

import './styles.css';

/**
 * A template for the landing page case studies section.
 *
 * @typedef {Object} Props
 * @prop {Array} cases
 * @prop {String} heading
 * @prop {String} [logosImageUrl]
 *
 * @augments {Component<Props>}
 */
export default class CaseStudies extends Component {

	genCases = (cases = []) => cases.map((caseItem) => <CaseTile key={caseItem.imageName} {...caseItem} />)

	render () {
		const { cases, heading } = this.props;

		return (
			<PaddedSection className='CaseStudies'>
				<h1>{heading}</h1>
				<div className='CaseStudies-cases'>
					<div className='CaseStudies-row'>
						{this.genCases(cases)}
					</div>
				</div>
			</PaddedSection>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/templates/CaseStudies/CaseStudies.js